export default __webpack_public_path__ + "static/media/residence-type-flat.696416ae.jpg";